import { orderStatus } from './orderStatus';
import attendCode from './attendCode';
/** 프로젝션 키울 값 */
export const EXTEND_SIZE = 100;
/** 프로젝션 줄일 값 */
export const REDUCE_SIZE = -50;
export const mapBoundary = {
    INSIDE: 'INSIDE',
    OUTSIDE: 'OUTSIDE',
    ORIGIN: 'ORIGIN',
};
// 주문 최대 선택 가능 개수
const SELECT_ORDER_MAX_COUNT = 6;
/** 지도관제 필터 */
const orderStatusGroupList = {
    [orderStatus.ALL.code]: orderStatus.ALL,
    [orderStatus.ACCEPTED.code]: orderStatus.ACCEPTED,
    [orderStatus.ALLOCATED.code]: orderStatus.ALLOCATED,
    [orderStatus.PICKUP.code]: orderStatus.PICKUP,
};
/**
 * 주문의 orderStatus가 현재 필터 리스트에 포함되는지 여부 판단
 * 예를 들면 배차요청은 상태는 배차 필터에서 보여져야 한다.
 * 픽업 도착은 아직은 배차 필터에 보여져야 한다 등등을 분리
 *
 * 배차 취소 => 접수 필터에서 보여야 함
 */
export const orderStatusGroup = {
    // 접수
    [orderStatus.ALLOCATE_CANCEL.code]: orderStatus.ACCEPTED.code,
    [orderStatus.RESERVED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.ACCEPTED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.RESERVE_END.code]: orderStatus.ACCEPTED.code,
    [orderStatus.WORKER_REQUESTED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.RE_ACCEPT.code]: orderStatus.ACCEPTED.code,
    [orderStatus.ALLOCATE_REJECTED.code]: orderStatus.ACCEPTED.code,
    [orderStatus.PRIORITY_ALLOCATE_CANCEL.code]: orderStatus.ALLOCATED.code,
    // 배차
    [orderStatus.PRIORITY_ALLOCATE.code]: orderStatus.ALLOCATED.code,
    [orderStatus.IMMEDIATE_ALLOCATE.code]: orderStatus.ALLOCATED.code,
    [orderStatus.ALLOCATED.code]: orderStatus.ALLOCATED.code,
    [orderStatus.PICKUP_ARRIVED.code]: orderStatus.ALLOCATED.code,
    [orderStatus.WORKER_REQUESTED_CANCEL.code]: orderStatus.ALLOCATED.code,
    // 픽업
    [orderStatus.PICKUP.code]: orderStatus.PICKUP.code,
    [orderStatus.PICKUP_FINISHED.code]: orderStatus.PICKUP.code,
    // 자체
    [orderStatus.SELF.code]: orderStatus.SELF.code,
    [orderStatus.SELF_DELIVERY.code]: orderStatus.SELF.code,
    [orderStatus.SELF_DELIVERING.code]: orderStatus.SELF.code,
    // 완료
    [orderStatus.DROP_FINISHED.code]: orderStatus.DROP_FINISHED.code,
    [orderStatus.SELF_DROP_FINISHED.code]: orderStatus.DROP_FINISHED.code,
    // 취소
    [orderStatus.CANCELED.code]: orderStatus.CANCELED.code,
    // 이하 확인 필요
    [orderStatus.ORDER.code]: orderStatus.ORDER.code,
    [orderStatus.ORDER_REJECT.code]: orderStatus.ORDER_REJECT.code,
    [orderStatus.ORDER_MODIFY.code]: orderStatus.ORDER_MODIFY.code,
    [orderStatus.ALL.code]: orderStatus.ALL.code,
    [orderStatus.NONE.code]: orderStatus.NONE.code,
    [orderStatus.QUESTION.code]: orderStatus.QUESTION.code,
    [orderStatus.SETTLED.code]: orderStatus.SETTLED.code,
    [orderStatus.WAITED.code]: orderStatus.WAITED.code,
    [orderStatus.WAIT_END.code]: orderStatus.WAIT_END.code,
};
// 지도관제 라이더 목록 필터
const mapControlAttendCode = {
    ALL: {
        type: 'all',
        code: 'ALL',
        text: 'views.map_control.worker_wrapper.filter_all',
        color: '',
        textColor: '#000000',
    },
    SHARE: {
        type: 'share',
        code: 'SHARE',
        text: 'common.share',
        color: '',
        textColor: '#F57C00',
    },
    ...attendCode,
};
// 지도관제 라이더 필터 그룹
const mapControlWorkerFilterGroup = {
    WAITING: [
        mapControlAttendCode.WAITING.code,
    ],
    DRIVING: [
        mapControlAttendCode.ALLOCATED.code,
        mapControlAttendCode.DRIVING.code,
    ],
    REST: [
        mapControlAttendCode.REST.code,
    ],
    SHARE: [
        mapControlAttendCode.SHARE.code,
    ],
};
// 지도관제용 attendCode group
const mapControlWorkerAttendCodeGroup = {
    [mapControlAttendCode.WAITING.code]: mapControlAttendCode.WAITING.code,
    [mapControlAttendCode.ALLOCATED.code]: mapControlAttendCode.DRIVING.code,
    [mapControlAttendCode.DRIVING.code]: mapControlAttendCode.DRIVING.code,
    [mapControlAttendCode.REST.code]: mapControlAttendCode.REST.code,
};
const marker = {
    WORKER: 'WORKER',
    STORE: 'STORE',
    DROP: 'DROP',
};
const HUB = 'HUB';
const DIST = 'DIST';
const LINE_COLOR = {
    [orderStatus.ACCEPTED.code]: '#00A7FF',
    [orderStatus.ALLOCATED.code]: '#00A7FF',
    [orderStatus.PICKUP_FINISHED.code]: '#6D4C41',
};
export default {
    LINE_COLOR,
    HUB,
    DIST,
    marker,
    EXTEND_SIZE,
    REDUCE_SIZE,
    SELECT_ORDER_MAX_COUNT,
    orderStatusGroupList,
    orderStatusGroup,
    mapControlAttendCode,
    mapControlWorkerFilterGroup,
    mapControlWorkerAttendCodeGroup,
    MARKER_ICON_TYPE: {
        SHARE: 'share',
        NORMAL: 'normal',
        DEPLAY: 'delay',
    },
    MARKER_ICON_STATE: {
        DEFAULT: 'default',
        ACTIVE: 'active',
        RELATED: 'related',
    },
    mapBoundary,
};
